module.exports = __webpack_public_path__ + "static/media/joomla.700fca52.svg";